module.exports = __webpack_public_path__ + "89bcd454969ae84ee806d15236431e3b.png";